$(function () {

	// var aanimals = [{ a: 1, b: 2 }, { a: 3, b: 4 }]
	// for (var i = 0; i < aanimals.length; i++) {
	// 	(function (e) {
	// 		this.print = function () {
	// 			console.log('#' + e + this.a + ':' + this.b)
	// 		}
	// 		this.print()
	// 	}).call(aanimals[i], i + 1)
	// }

	const wW = $(window).width();

	//导航悬停  滚动条下拉隐藏，上拉显示
	$('.header').$scrollH('.header', "headbg", 1, 0, "collapsed");

	// 查看更多 js css
	$('.com-seemore').off("click").on("click", function () {
		$(this).closest('.seemore-p').toggleClass('isseemore');
		$(this).toggleClass('active');
	});


	// getRow({
	// 	p: '#mcoty', li的父级
	// 	li: '.swiper-slide', 每一项
	// 	limit: 5, 限制几行
	// 	addName: 'isoverflow', 添加什么类名
	// 	addtarget: '.seemore-p', 谁添加类名
	// })

	function getRow(e) {
		let {
			p,
			li,
			addName,
			addtarget,
			limit
		} = e;
		let list = $(p).find(li);
		// console.log(list);

		list.each(function (i, ele) {
			// let fs = $(this).css('font-size');
			let lh = parseFloat($(this).css('line-height'));
			let myh = $(this).height();

			let finalh = lh * limit; // 最高多高

			let row = Math.round(myh / parseFloat(lh)); // 现在几行
			let top = $(this).scrollTop(); // 现在几行

			if (myh >= finalh) {
				// console.log($(p).find(addtarget).eq(i));
				// $(p).find(addtarget).eq(i).addClass(addName);
				$(this).closest(addtarget).addClass(addName);
				// debugger
			} else {
				// $(p).find(addtarget).addClass('bugou');
			}
			console.log({
				lh,
				myh,
				finalh,
				i,
				top
			})
			// debugger



		});
	};
	if ($('#mcoty').length > 0) {
		getRow({
			p: '#mcoty',
			li: '.swiper-slide .desc',
			limit: 5,
			addName: 'isoverflow',
			addtarget: '.seemore-p',
		})
	}





	function waterfallInit(e) {
		let {
			p,
			li,
			colName,
			rule
		} = e;
		let windowW = $(window).width();
		let col, col_spacing, row_spacing;

		// let init = false;
		for (let rkey in rule) {
			if (windowW >= rkey) {
				col = rule[rkey].column;
				col_spacing = rule[rkey].col_spacing;
				row_spacing = rule[rkey].row_spacing;
				// init = true;
			}
		}

		// 全部item
		let fallList = $(p).find(li);

		// 列标签
		let colele = `
		<div class="${colName}" style="row-gap: ${row_spacing}px">
			
		</div>
		`

		if ($(p).find(`.${colName}`).length > 0) {
			$(li).unwrap();

			fallList.sort(function (a, b) {
				let x = $(a).attr('data-index')
				let y = $(b).attr('data-index')
				// console.log(x);




				return x - y;
			})
			// console.log(fallList);
			// return
		}

		// console.log(rule)
		// if (!init) return
		// if ($(p).find(`.${colName}`).length > 0) {
		// 	$(li).unwrap();
		// }
		fallList.each(function (i, ele) {
			let myHeight = $(this).height();
			$(this).attr('myheight', myHeight);
		})

		$(p).css({
			'display': 'grid',
			'grid-template-columns': `repeat(${col}, 1fr)`,
			'grid-column-gap': `${col_spacing}px`
		})
		// 每列的高度
		let col_height_obj = [];



		// 初始化列高度 为0
		for (var i = 0; i < col; i++) {
			col_height_obj[i] = 0
			$(p).append(colele);
		}


		let collist = $(p).find(`.${colName}`);
		// 容器宽度
		let pW = $(p).width();

		// item宽度
		let itemW = (pW - ((col - 1) * col_spacing)) / col;




		fallList.each(function (i, ele) {
			$(this).css('width', itemW);


			// 最小高度
			let minHeight = Math.min(...col_height_obj)
			// 最小高度列的索引
			let minHeight_index = col_height_obj.indexOf(minHeight);


			let eleHeight = parseInt($(this).attr('myheight'));


			// console.log('数组', col_height_obj);
			// console.log('minHeight_index', minHeight_index);

			// console.log('i', i);
			// console.log('eleHeight', eleHeight);

			// console.log('ele', ele);


			// for (let index in col_height_obj) {

			// 	if (col_height_obj[index] < minHeight) {
			// 		minHeight_index = index;
			// 		console.log(i, minHeight, minHeight_index)
			// 		break
			// 	}

			// }
			$(ele).appendTo(collist.eq(minHeight_index));
			// col_height_obj[minHeight_index] += eleHeight;
			col_height_obj[minHeight_index] = $(`.${colName}`).eq(minHeight_index).height();

		})

		// fallList.each(function (i, ele) {
		// 	let eleHeight = $(this).height();
		// 	console.log('eleHeight', eleHeight);

		// })
	};

	function loadInit() {
		if ($('.community-waterfall').length > 0) {


			waterfallInit({
				p: '.community-waterfall',
				li: '.fall-item',
				colName: 'fall-col',
				rule: {
					1280: {
						column: 4,
						row_spacing: 40,
						col_spacing: 20
					},
					1024: {
						column: 3,
						row_spacing: 40,
						col_spacing: 20
					},
					768: {
						column: 2,
						row_spacing: 24,
						col_spacing: 20
					},
					320: {
						column: 1,
						row_spacing: 24,
						col_spacing: 20
					},
				},
			})
			getRow({
				p: '.community-waterfall',
				li: '.desc',
				limit: 10,
				addName: 'isoverflow',
				addtarget: '.seemore-p',
			})
		}

	}


	var loadInitTask = null;

	$(window).resize(function () {
		// if ($(window).width() == 1280) {
		clearTimeout(loadInitTask);
		loadInitTask = setTimeout(function () {
			loadInit()
		}, 50);
		// }
	});
	loadInit()



	//搜索
	//搜索框点击显示搜索框
	$('.search .box').$toclick_hover({
		$OtherThis: "1",
		$bodyclick: "1",
		$usother: "0",
		$on: "click",
		$BoxClass: ".search .box",
		$ToggleClass: ".search .toggle"
	});

	//搜索框显示时候，自动获取焦点
	$('.search .box').on("click", function (e) {
		if ($(".search .toggle").is(".active") == true) {
			$("#key").focus();
			$(".hotname").slideDown();
			$(".lang .box").removeClass('active');
			$(".lang .toggle").removeClass('active');
		} else {
			$(".hotname").slideUp();
			$(".search .box").removeClass('active');
			$(".search .toggle").removeClass('active');
		}
	});

	//搜索框失去焦点
	$("#key").blur(function () {
		/*$(".search").children().removeClass('active');*/
		$(".hotname").slideUp();
	});
	//搜索框获取焦点
	$("#key").focus(function () {
		$(".search").children().addClass('active');
		$(".hotname").slideDown();
	});

	//搜索框失去焦点
	$("#m-key").blur(function () {
		$(".mobile .search").removeClass('active');
		$(".mobile .nav").removeClass("active");
	});
	//搜索框获取焦点
	$("#m-key").focus(function () {
		$(".mobile .search").addClass('active');
		$(".mobile .nav").addClass("active");
	});

	//搜索内容为空禁止跳转
	$('.search-go').on("click", function (e) {

		var searchval = $("#key").val();
		var searchreg = /^[\u4e00-\u9fa5-_a-zA-Z0-9]+$/;
		searchgo = searchreg.test(searchval);
		if (searchgo) {
			$(this).attr("type", "submit");
		}

	});



	$('.enterInp').on("keydown", function (e) {
		if (e.keyCode == '13') {
			var searchval = $(this).val();
			var searchreg = /^[\u4e00-\u9fa5-_a-zA-Z0-9]+$/;
			searchgo = searchreg.test(searchval);
			if (searchgo) {
				$(this).closest('form').submit();
			}
			return false
		}
	});

	//搜索内容为空禁止跳转
	$('.formbtn').on("click", function (e) {

		var searchval = $(this).siblings().find('input').val();
		var searchreg = /^[\u4e00-\u9fa5-_a-zA-Z0-9]+$/;
		searchgo = searchreg.test(searchval);
		// debugger
		if (searchgo) {
			$(this).attr("type", "submit");
		}

	});

	//搜索内容为空禁止跳转
	$('.search-go-sub').on("click", function (e) {

		var searchval = $("#key2").val();
		var searchreg = /^[\u4e00-\u9fa5-_a-zA-Z0-9]+$/;
		searchgo = searchreg.test(searchval);
		// debugger
		if (searchgo) {
			$(this).attr("type", "submit");
		}

	});


	//多语言
	$('.lang .box').hover(function () {
		$(".search .box").removeClass('active');
		$(".search .toggle").removeClass('active');
	});


	//导航栏目

	// $('.infodrop .info .infoli').$toclick_hover({
	// 	$OtherThis: "0",
	// 	$bodyclick: "0",
	// 	$usother: "1",
	// 	$on: "hover",
	// 	$BoxClass: ".infodrop .info .infoli",
	// 	$ToggleClass: ".infodrop .sort"
	// });

	$('.infodrop .info .infoli').each((index,item)=>{
		$(item).hover(()=>{

			
			$(item).siblings().removeClass('active')
			$(item).addClass('active')
			let sortChildren = $('.infodrop .sort .sortul')
			let parent =  $(item).closest('.infodrop')
			let children = parent.find(".sortul")
			children.removeClass('active')
			sortChildren.eq(index).addClass('active')
		})
	})



	//整站动效
	var move = new WOW({
		boxClass: 'fadeInUp',
		animateClass: 'animated',
		offset: 0,
		mobile: true,
		live: true
	});
	move.init();


	//禁止滚动条滚动
	function unScroll() {
		// var top = $(document).scrollTop();
		// $(document).on('scroll.unable',function (e) {
		//     $(document).scrollTop(top);
		// })

		// $('html').css({
		// 	'max-height': 'var(--window_height)',
		// 	'overflow': 'hidden',
		// })
		$('body').addClass('click_nav')
	}
	//移除禁止滚动条滚动
	function removeUnScroll() {
		// $(document).unbind("scroll.unable");

		// $('html').css('overflow', 'auto')
		$('body').removeClass('click_nav')

	}

	// $(".header .mobile .nav-name ul").unbind("scroll.unable");


	//手机导航
	var navBtnBool = true;
	$(".header .bar").on("click", function (e) {
		$(this).toggleClass('active');
		$('.mybar .close').click();
		var is_on = $(this).is('.active');
		if (is_on) {
			unScroll()
			$(".header .mobile .toggle").addClass('active');
		} else {
			removeUnScroll()
			$(".header .mobile .toggle").removeClass('active');
		}
	});
	$(".mybar .close").on("click", function (e) {
		$('.mybar ').hide();
		if ($('.banner').length > 0) {
			$('.banner').removeClass('hasbar')
		}
		return false;
	});
	//手机导航切换
	$('.nav-name li').$toclick_hover({
		$OtherThis: "0",
		$bodyclick: "0",
		$usother: "1",
		$on: "click",
		$BoxClass: ".nav-name li",
		$ToggleClass: ".nav-img ul",
		$needActive: "true"
	});


	//底部下拉菜单
	$('.fnavli').on("click", function (e) {
		$(this).toggleClass('active').siblings().removeClass("active");
	});


	//速度差
	function speedbox_fun() {

		var winst = $(window).scrollTop();
		var winh = $(window).height();
		var item = $(".speed-d-box");

		for (var index = 0; index < item.length; index++) {
			var itemtop = $(item).eq(index).offset().top;
			var itemh = $(item).eq(index).height();
			var itembgh = $(item).eq(index).find(".speed-bg").eq(0).height();

			var cha = 0;
			if (cha < 0) cha = 0;

			var zonggao = itemtop + itemh;
			if (winst + winh - itemtop >= 0) {
				var pianyi = ((winst + winh - itemtop) / winh * cha) / itembgh - (cha / itembgh);
				if (pianyi > cha / itembgh) pianyi = cha / itembgh
				$(item).eq(index).find(".speed-bg").eq(0).css("transform", "translateY(" + pianyi * 100 + "%)");
			}

		}
	}


	//视频自动播放（视频可见范围超过一半时播放，小于一半时暂停）
	var init = {};
	var scrollFlag = true;
	var windoShow = 0.7;
	var videoShow = 0.6;



	function video_autoplay() {

		if (!scrollFlag) return
		scrollFlag = false;
		var Wtop = $(window).scrollTop();
		var WH = $(window).height();
		var video = $(".video_autoplay").find("video");
		for (var index = 0; index < video.length; index++) {

			var videotop = $(video).eq(index).offset().top;
			var videoh = $(video).eq(index).height();
			// var half_out = Wtop - videotop - (videoh / 2);
			// var half_in = Wtop - videotop - (videoh / 2) + WH;
			// if (half_in > 0) {//进入视频播放阶段
			// 	if (half_out > 0) {
			// 		$(video).eq(index)[0].pause();
			// 	} else {
			// 		$(video).eq(index)[0].play();
			// 	}
			// } else {
			// 	$(video).eq(index)[0].pause();
			// }
			// $(video[index]).off("ended");
			// $(video[index]).on('ended', function (e) {
			// 	console.log(index, '结束了')
			// })
			// 元素高度大于获得于整屏
			if (videoh >= WH) {
				// 如果滚动距离小于 元素距离顶部的距离再加上自身的高度 -----比如视野看到元素 videoShow 漏出了 0.7  或者全部漏出
				// 如果滚动距离大于 元素距离顶部的距离再加上 窗口的高度 -----即看到元素隐藏了 windoShow 窗口多少就暂停播放
				var readyPlay = Wtop < videotop + (videoh * videoShow) && Wtop > videotop - (WH * windoShow) ? true : false;
				// console.log({
				// 	"滚动距离": Wtop,
				// 	'我离顶部距离': videotop,
				// 	'条件': videotop + WH + videoh,
				// })
			} else {
				// 要看到元素videoShow 部分 并且 没有开始隐藏元素videoShow部分 才播放
				// var readyPlay = Wtop + (WH * windoShow) > videotop && Wtop + WH < videotop + videoh ? true : false;
				var readyPlay = Wtop + WH > videotop + (videoh * videoShow) && Wtop < videotop + (videoh * videoShow) ? true : false;
				// console.log({
				// 	"滚动距离": Wtop,
				// 	'我离顶部距离': videotop,
				// 	'条件': videotop + (videoh * videoShow),
				// 	'条件2': videotop - (videoh * videoShow),
				// })
			}

			if (readyPlay) {
				$(video).eq(index)[0].play();
				$(video).eq(index).attr('loop', true);


			} else {
				$(video).eq(index)[0].pause();
			}
			// console.log('循环')
		}
		scrollFlag = true;
	}

	//speedbox_fun();
	video_autoplay();


	$(window).scroll(function () {

		/*右侧客服根据离顶部高度 显示隐藏*/
		// if ($(this).scrollTop() > 100) {
		// 	$('#ToTop').addClass("active");
		// } else {
		// 	$('#ToTop').removeClass("active");
		// }

		//页面顶部向下时，隐藏搜索栏
		// if ($(".header").is(".collapsed")) {
		// 	if ($(".header .menu .hide-search").is(".active")) {
		// 		$(".header .menu .search>div").removeClass("active");
		// 	}
		// }


		//speedbox_fun();
		video_autoplay();

		//导航悬停  滚动条下拉隐藏，上拉显示
		// $('.header').$scrollH('.header', "headbg", 1, 0, "collapsed");
	});

	$(window).resize(function () {
		//speedbox_fun();
		// video_autoplay();
	});


	$(document).mousemove(function (e) {
		if (!!this.move) {
			var posix = !document.move_target ? {
				'x': 0,
				'y': 0
			} : document.move_target.posix;
			var callback = document.call_down || function () {
				$(this.move_target).css({
						// 'top': e.pageY - posix.y,
						// 'left': e.pageX - posix.x
					}

				);
			};
			callback.call(this, e, posix);
		}
	}).mouseup(function (e) {
			if (!!this.move) {
				var callback = document.call_up || function () {};
				callback.call(this, e);
				$.extend(this, {
						'move': false,
						'move_target': null,
						'call_down': false,
						'call_up': false
					}

				);
			}
		}

	);

	var $box = $('#coor-box').mousedown(function (e) {
		var offset = $(this).offset(); // 距离左边上面的距离
		this.posix = {
			'x': e.pageX - offset.left,
			'y': e.pageY - offset.top
		}; // 鼠标点击距离元素左和上的距离
		$.extend(document, {
			'move': true,
			'move_target': this
		});
		// debugger
	}).on('mousedown', '#coor', function (e) {
			var posix = {
				'w': $box.width(),
				'h': $box.height(),
				'x': e.pageX, //鼠标点击距离左边的大小
				'y': e.pageY //鼠标点击距离上边的大小
			};
			// console.log()
			$.extend(document, {
				'move': true,
				'call_down': function (e) {
					$box.css({
							'width': Math.max(e.pageX - posix.x + posix.w),
							// 'height': Math.max(e.pageY - posix.y + posix.h)
						}

					);
				}
			});
			// debugger
			return false;
		}

	);




});